import { useInfiniteQuery } from "@tanstack/react-query";
import calendarEventApiClient from "../../../api/calendarEvent";

const useCalendarEventsInfiniteQuery = (searchQuery: string) => {
  const limit = 10;

  const { data, fetchNextPage, ...rest } = useInfiniteQuery({
    queryKey: ["calendar-event-list", searchQuery],
    queryFn: async ({ pageParam = 0 }) => {
      return calendarEventApiClient.calendarEventsSearch({
        query: searchQuery,
        skip: pageParam,
        limit,
      });
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.length < limit) {
        return undefined;
      }
      return allPages.length * limit;
    },
    initialPageParam: 0,
  });

  return {
    data: data?.pages.flat(),
    fetchNextPage,
    ...rest,
  };
};

export default useCalendarEventsInfiniteQuery;
